export default __webpack_public_path__ + "static/media/mlp-stethoscope.31da3e7e.svg";